<app-carousel-full-image />

@let localGallery = gallery(); @let localNumMissingImages = numMissingImages();

<div class="container-gallery d-none d-md-grid" [class]="classNumImages()">
  @for (item of localGallery.slice(0, MAX_IMAGES()); track item) {
    <div
      class="gallery overflow-hidden cursor-pointer rounded-3 position-relative"
      [class]="'gallery-' + ($index + 1)"
      (click)="openCarousel($index)"
    >
      @if (item.isImage) {
        <img
          class="w-100 h-100 object-fit-cover rounded-3"
          [lazyLoad]="item.url | cdnUrl: 800 : true"
          [alt]="item.url"
          (load)="onImageLoaded($index)"
        />
        @if (loadingImages()[$index]) {
        <div
          class="position-absolute start-50 top-50 translate-middle d-flex justify-content-center align-items-center"
          style="background-color: rgba(255,255,255,0.5); width: 100%; height: 100%;"
        >
          <mat-spinner color="inherit" [diameter]="50" class="custom-spinner"></mat-spinner>
        </div>
        }
      } @else {
        <video class="w-100 h-100 object-fit-cover rounded-3" controls>
          <source [src]="item.url" type="video/mp4" />
        </video>
      }
      @if (localNumMissingImages > 0 && $last) {
        <div
          class="position-absolute w-100 h-100 top-0 start-0 d-flex justify-content-center align-items-center"
          style="background-color: rgba(0, 0, 0, 0.8)"
        >
          <span class="text-white">{{ localNumMissingImages }} fotos más</span>
        </div>
      }
    </div>
  }
</div>

<div class="container-gallery-mobile d-grid d-md-none" [class]="classNumImages()">
  @for (item of localGallery.slice(0, MAX_IMAGES()); track item) {
    <div
      class="gallery overflow-hidden cursor-pointer rounded-3 position-relative"
      [class]="'gallery-' + ($index + 1)"
      (click)="openCarousel($index)"
    >
      @if (item.isImage) {
        <img
          class="w-100 h-100 object-fit-cover rounded-3"
          [lazyLoad]="item.url | cdnUrl: 800 : true"
          [alt]="item.url"
          (load)="onImageLoaded($index)"
        />
  @if (loadingImages()[$index]){
  <div
    class="position-absolute start-50 top-50 translate-middle d-flex justify-content-center align-items-center"
    style="background-color: rgba(255,255,255,0.5); width: 100%; height: 100%;"
  >
    <mat-spinner color="inherit" [diameter]="50" class="custom-spinner"></mat-spinner>
  </div>
  }
      } @else {
        <video class="w-100 h-100 object-fit-cover rounded-3" controls>
          <source [src]="item.url" type="video/mp4" />
        </video>
      }
      @if (localNumMissingImages > 0 && $last) {
        <div
          class="position-absolute w-100 h-100 top-0 start-0 d-flex justify-content-center align-items-center"
          style="background-color: rgba(0, 0, 0, 0.8)"
        >
          <span class="text-white">{{ localNumMissingImages }} fotos más</span>
        </div>
      }
    </div>
  }
</div>
